import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Card, Form, Button, Alert, Spinner } from 'react-bootstrap';
import { useAuth } from '../contexts/AuthContext';
import api, { formatApiErrorDetail } from '../services/api';

const ChangePassword = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [formData, setFormData] = useState({
    current_password: '',
    new_password: '',
    confirm_password: ''
  });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess(false);

    // Validaciones
    if (!formData.current_password) {
      setError('Por favor ingresa tu contraseña actual');
      return;
    }

    if (!formData.new_password) {
      setError('Por favor ingresa tu nueva contraseña');
      return;
    }

    if (formData.new_password.length < 6) {
      setError('La nueva contraseña debe tener al menos 6 caracteres');
      return;
    }

    if (formData.new_password.length > 72) {
      setError('La nueva contraseña no puede tener más de 72 caracteres');
      return;
    }

    if (formData.new_password !== formData.confirm_password) {
      setError('Las contraseñas no coinciden');
      return;
    }

    if (formData.current_password === formData.new_password) {
      setError('La nueva contraseña debe ser diferente a la actual');
      return;
    }

    setLoading(true);
    try {
      await api.put('/api/v1/usuarios/me/change-password', {
        current_password: formData.current_password,
        new_password: formData.new_password
      });
      setSuccess(true);
      setFormData({
        current_password: '',
        new_password: '',
        confirm_password: ''
      });
      setTimeout(() => {
        navigate(-1); // Volver a la página anterior
      }, 2000);
    } catch (error) {
      console.error('Error changing password:', error);
      setError(formatApiErrorDetail(error, 'Error al cambiar la contraseña. Verifica que la contraseña actual sea correcta.'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div 
      className="min-vh-100 d-flex align-items-center"
      style={{
        backgroundColor: '#f5f7fa'
      }}
    >
      <Container>
        <div className="d-flex justify-content-center">
          <Card className="shadow-lg border-0" style={{ maxWidth: '500px', width: '100%' }}>
            <Card.Body className="p-4 p-md-5">
              <div className="text-center mb-4">
                <div className="mb-3" style={{ fontSize: '3rem' }}>
                  🔐
                </div>
                <h2 className="fw-bold text-primary mb-2">Cambiar Contraseña</h2>
                <p className="text-muted">Actualiza tu contraseña de acceso</p>
              </div>

              {success && (
                <Alert variant="success" className="mb-4">
                  <Alert.Heading>¡Contraseña Actualizada!</Alert.Heading>
                  <p>Tu contraseña ha sido actualizada exitosamente. Redirigiendo...</p>
                </Alert>
              )}

              {error && (
                <Alert variant="danger" dismissible onClose={() => setError('')} className="mb-4">
                  <i className="bi bi-exclamation-triangle-fill me-2"></i>
                  {error}
                </Alert>
              )}

              {!success && (
                <Form onSubmit={handleSubmit}>
                  <Form.Group className="mb-3">
                    <Form.Label>Contraseña Actual *</Form.Label>
                    <Form.Control
                      type="password"
                      placeholder="Ingresa tu contraseña actual"
                      value={formData.current_password}
                      onChange={(e) => setFormData({ ...formData, current_password: e.target.value })}
                      required
                      disabled={loading}
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Nueva Contraseña *</Form.Label>
                    <Form.Control
                      type="password"
                      placeholder="Ingresa tu nueva contraseña"
                      value={formData.new_password}
                      onChange={(e) => setFormData({ ...formData, new_password: e.target.value })}
                      required
                      minLength={6}
                      maxLength={72}
                      disabled={loading}
                    />
                    <Form.Text className="text-muted">
                      Mínimo 6 caracteres, máximo 72 caracteres
                    </Form.Text>
                  </Form.Group>

                  <Form.Group className="mb-4">
                    <Form.Label>Confirmar Nueva Contraseña *</Form.Label>
                    <Form.Control
                      type="password"
                      placeholder="Confirma tu nueva contraseña"
                      value={formData.confirm_password}
                      onChange={(e) => setFormData({ ...formData, confirm_password: e.target.value })}
                      required
                      minLength={6}
                      maxLength={72}
                      disabled={loading}
                    />
                  </Form.Group>

                  <div className="d-grid gap-2">
                    <Button 
                      variant="primary" 
                      type="submit"
                      size="lg"
                      disabled={loading}
                    >
                      {loading ? (
                        <>
                          <Spinner animation="border" size="sm" className="me-2" />
                          Actualizando...
                        </>
                      ) : (
                        <>
                          <i className="bi bi-key me-2"></i>
                          Cambiar Contraseña
                        </>
                      )}
                    </Button>
                    <Button 
                      variant="outline-secondary" 
                      onClick={() => navigate(-1)}
                      disabled={loading}
                    >
                      Cancelar
                    </Button>
                  </div>
                </Form>
              )}
            </Card.Body>
          </Card>
        </div>
      </Container>
    </div>
  );
};

export default ChangePassword;

